import React, { useState, useRef, useEffect } from 'react';
import { useHistory } from 'react-router';
import './Auth.css';
import axios from 'axios';
import CircularProgress from '@mui/material/CircularProgress';
import { apilink } from '../../data/fdata';
import validator from 'validator';
import { useAlert } from 'react-alert';
import crypto from 'crypto-js';
import { stateList } from '../../data/stateList';

const Register = () => {
  const alert = useAlert();
  const [lname, setLName] = useState('');
  const [mname, setMName] = useState('');
  const [fname, setFName] = useState('');

  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');

  const [gender, setGender] = useState('');
  const [dob, setDob] = useState('');

  const [bloodg, setBloodG] = useState('');
  const [street, setStreet] = useState('');
  const [houseno, setHouseNo] = useState('');
  const [district, setDistrict] = useState('');
  const [country, setCountry] = useState('');
  const [pin, setPin] = useState('');

  const [state, setState] = useState('');
  const [city, setCity] = useState('');

  const [npassword, setNPassword] = useState('');
  const [cpassword, setCPassword] = useState('');

  const [status, setStatus] = useState(false);
  const [loading, setLoading] = useState(false);
  const [coll, setColl] = useState(false);
  const [msg, setMsg] = useState('');
  const his = useHistory();

  useEffect(() => {
    // 👇️ scroll to top on page load
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
  }, []);

  const validName = (nm) => {
    // let reg = /^[a-zA-Z\\s]*$/;
    let reg = /^[A-z]*$|^[A-z]+\s[A-z]*$/;

    if (!nm.match(reg)) {
      return false;
    }
    return true;
  };

  const invalidBlood = (bl) => {
    let bloodType = ['A+', 'A-', 'B+', 'B-', 'AB+', 'AB-', 'O+', 'O-'];
    if (!bloodType.includes(bl.toUpperCase())) {
      return false;
    }
    return true;
  };

  const isValidPhoneNumber = (phoneno) => {
    let isValidNumber = false;
    let reg = /^(\d)(?!\1+$)\d*$/;
    let regg = /^\d{10}$/;
    // console.log(phoneno.substring(0, 9));

    let invalidarr = ['0', '1', '2', '3', '4', '5'];

    if (invalidarr.includes(phoneno.substring(0, 1))) {
      return false;
    }
    if (
      validator.isMobilePhone(phoneno) &&
      phone.match(reg) &&
      phone.match(regg)
    ) {
      isValidNumber = true;
    }

    return isValidNumber;
  };

  const onSub = async (e) => {
    // alert.show('hi');
    e.preventDefault();
    // setLoading(true);

    let isValidPhNumber = isValidPhoneNumber(phone);
    let isValidBlood = invalidBlood(bloodg);
    let isvalidname1 = validName(fname);
    let isvalidname2 = validName(mname);
    let isvalidname3 = validName(lname);
    // console.log(isvalidname1);

    if (!isvalidname1) {
      setStatus(true);
      setMsg('Invalid FirstName');
      return;
    }
    if (!isvalidname2) {
      setStatus(true);
      setMsg('Invalid MiddleName');
      return;
    }
    if (!isvalidname3) {
      setStatus(true);
      setMsg('Invalid LastName');
      return;
    }

    if (!isValidPhNumber) {
      setStatus(true);
      setMsg('Invalid Phone Number');
      return;
    }
    if (!isValidBlood) {
      setStatus(true);
      setMsg('Invalid Blood Group');
      return;
    }

    if (npassword.length < 7) {
      setStatus(true);
      setMsg('Password should be more than 6 characters');
      return;
    } else if (npassword !== cpassword) {
      setStatus(true);
      setMsg('Both Password not matched');
      return;
    } else if (
      validator.isStrongPassword(npassword, {
        minLength: 8,
        minLowercase: 1,
        minUppercase: 1,
        minNumbers: 1,
        minSymbols: 1,
      })
    ) {
      let hash = phone + fname + lname;
      const data = {
        id: crypto.MD5(hash).toString(),
        fname,
        mname,
        lname,
        email,
        phone,
        gender,
        blood_group: bloodg,
        dob,
        district,
        street,
        houseno,
        city,
        state,
        country,
        pin,
        password: npassword,
      };

      const res = await axios.post(`${apilink}/api/user/register`, data);
      if (res.data.success) {
        his.push('/login');
      } else {
        setStatus(true);
        setMsg(res.data.msg);
      }

      // console.log(data);
    } else {
      setStatus(true);
      setMsg(
        'Use Strong Password , Password should consist minimum one number, one uppercase, one lowercase letters and one special character'
      );
    }
    //

    // setLoading(false);
  };

  return (
    <>
      <div className="auth">
        <div className="container">
          <div className="row">
            <div className="col-lg-8 col-md-12 col-12 mx-auto">
              <div className="card p-3">
                {status ? (
                  <>
                    <div
                      className={
                        coll
                          ? 'alert alert-success alert-dismissible'
                          : 'alert alert-warning alert-dismissible'
                      }
                    >
                      <button
                        type="button"
                        className="close"
                        data-dismiss="alert"
                        onClick={() => setStatus(false)}
                      >
                        &times;
                      </button>
                      {msg}
                    </div>
                  </>
                ) : null}

                <h3 className="text-center pb-3">Hecord SignUp</h3>
                <br />
                <form onSubmit={onSub} className="">
                  <div class="form-row">
                    <div className="form-group col-lg-4 col-md-4">
                      <input
                        type="text"
                        placeholder="Enter FirstName"
                        className="form-control"
                        name="fname"
                        value={fname}
                        onChange={(e) => setFName(e.target.value)}
                        required
                      />
                    </div>
                    <div className="form-group col-lg-4 col-md-4">
                      <input
                        type="text"
                        placeholder="Enter MiddleName"
                        className="form-control"
                        name="mname"
                        value={mname}
                        onChange={(e) => setMName(e.target.value)}
                      />
                    </div>
                    <div className="form-group col-lg-4 col-md-4">
                      <input
                        type="text"
                        placeholder="Enter LastName"
                        className="form-control"
                        name="lname"
                        value={lname}
                        onChange={(e) => setLName(e.target.value)}
                        required
                      />
                    </div>
                  </div>
                  {/* // email phone */}
                  <div class="form-row">
                    <div className="form-group col-lg-6 col-md-6">
                      <input
                        type="email"
                        placeholder="Enter Email"
                        className="form-control"
                        name="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                      />
                    </div>
                    <div className="form-group col-lg-6 col-md-6">
                      <input
                        type="tel"
                        placeholder="Enter Phone"
                        className="form-control"
                        name="phone"
                        maxLength={10}
                        value={phone}
                        onChange={(e) => setPhone(e.target.value)}
                        required
                      />
                    </div>
                  </div>
                  {/* // gender dob */}
                  <div className="form-row">
                    <div className="form-group col-lg-6 col-md-6">
                      <select
                        class="form-control"
                        value={gender}
                        onChange={(e) => setGender(e.target.value)}
                        required
                      >
                        <option selected hidden value="">
                          Choose Gender
                        </option>
                        <option value="Male">Male</option>
                        <option value="Female">Female</option>
                        <option value="Others">Others</option>
                      </select>
                    </div>
                    <div className="form-group col-lg-6 col-md-6">
                      <input
                        type="text"
                        class="form-control"
                        name="dob"
                        onFocus={(e) => (e.target.type = 'date')}
                        onBlur={(e) => (e.target.type = 'text')}
                        placeholder="Enter DOB"
                        value={dob}
                        onChange={(e) => setDob(e.target.value)}
                        required
                      />
                    </div>
                  </div>
                  {/* // blood, street */}
                  <div className="form-row">
                    <div className="form-group col-lg-6 col-md-6">
                      <input
                        type="text"
                        class="form-control"
                        name="blood"
                        value={bloodg}
                        placeholder="Enter Blood Group"
                        onChange={(e) => setBloodG(e.target.value)}
                        required
                      />
                    </div>
                    <div className="form-group col-lg-6 col-md-6">
                      <input
                        type="text"
                        class="form-control"
                        name="street"
                        placeholder="Enter Street"
                        value={street}
                        onChange={(e) => setStreet(e.target.value)}
                        required
                      />
                    </div>
                  </div>
                  <div className="form-row">
                    <div className="form-group col-lg-6 col-md-6">
                      <input
                        type="text"
                        class="form-control"
                        name="houseno"
                        value={houseno}
                        placeholder="Enter HouseNo"
                        onChange={(e) => setHouseNo(e.target.value)}
                        required
                      />
                    </div>
                    <div class="form-group col-lg-6 col-md-6">
                      <input
                        type="text"
                        class="form-control"
                        name="city"
                        value={city}
                        placeholder="Enter City"
                        onChange={(e) => setCity(e.target.value)}
                        required
                      />
                    </div>
                  </div>
                  {/* // CITY , STATE */}
                  <div className="form-row">
                    <div class="form-group col-lg-6 col-md-6">
                      <input
                        type="text"
                        class="form-control"
                        name="district"
                        value={district}
                        placeholder="Enter District"
                        onChange={(e) => setDistrict(e.target.value)}
                        required
                      />
                    </div>
                    <div class="form-group col-lg-6 col-md-6">
                      <select
                        class="form-control"
                        value={state}
                        onChange={(e) => setState(e.target.value)}
                        required
                      >
                        <option selected hidden value="">
                          --Choose State--
                        </option>
                        {stateList?.map((val, ind) => {
                          return (
                            <>
                              <option key={ind} value={val.state}>
                                {val.state}
                              </option>
                            </>
                          );
                        })}
                      </select>
                    </div>
                  </div>
                  {/* //country zip */}
                  <div className="form-row">
                    <div className="form-group col-lg-6 col-md-6">
                      <input
                        type="text"
                        placeholder="Enter Country"
                        className="form-control"
                        name="country"
                        value={country}
                        onChange={(e) => setCountry(e.target.value)}
                        required
                      />
                    </div>
                    <div class="form-group col-lg-6 col-md-6">
                      <input
                        type="number"
                        class="form-control"
                        placeholder="Enter Pincode"
                        name="pin"
                        value={pin}
                        onChange={(e) => setPin(e.target.value)}
                      />
                    </div>
                  </div>
                  {/* //password */}
                  <div className="form-row">
                    <div className="form-group col-lg-6 col-md-6">
                      <input
                        type="password"
                        placeholder="Enter Password"
                        className="form-control"
                        name="lname"
                        value={npassword}
                        onChange={(e) => setNPassword(e.target.value)}
                        required
                      />
                    </div>
                    <div className="form-group col-lg-6 col-md-6">
                      <input
                        type="password"
                        placeholder="Confirm Password"
                        className="form-control"
                        name="cpassword"
                        value={cpassword}
                        onChange={(e) => setCPassword(e.target.value)}
                        required
                      />
                    </div>
                  </div>
                  <div className="text-box">
                    <small
                      onClick={() => his.push('/login')}
                      style={{ cursor: 'pointer' }}
                    >
                      Already Have an Account?
                    </small>
                  </div>
                  <div className="text-center">
                    <button
                      type="submit"
                      className={
                        loading ? 'dis btn btn-primary' : 'btn btn-primary'
                      }
                      disabled={loading}
                    >
                      Register Now
                    </button>
                  </div>
                  {loading && (
                    <div className="text-center p-2">
                      <CircularProgress size={45} />
                    </div>
                  )}
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Register;
